import { render } from "./DebugNetQueueView.vue?vue&type=template&id=2ec28a4e&scoped=true&lang=html"
import script from "./DebugNetQueueView.vue?vue&type=script&lang=js"
export * from "./DebugNetQueueView.vue?vue&type=script&lang=js"

import "./DebugNetQueueView.vue?vue&type=style&index=0&id=2ec28a4e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec28a4e"]])

export default __exports__